import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    path: String,
    data: Object
  }

  connect() {
    // console.log("post-link controller connected");
  }

  submit(event) {
    event.preventDefault();

    const form = document.createElement("form");
    form.method = "POST";
    form.action = this.pathValue;

    // CSRF token
    const token = document.querySelector("meta[name='csrf-token']").content;
    form.innerHTML += `<input type="hidden" name="authenticity_token" value="${token}">`;

    Object.entries(this.dataValue).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;

      if (Array.isArray(value)) {
        input.value = value.join(",");
      } else {
        input.value = value;
      }

      form.appendChild(input);
    });
    // Add hidden fields
    // Object.entries(this.dataValue).forEach(([key, value]) => {
    //   console.log(`--->>>> key: ${key}, value: ${value}`);
    //   if (Array.isArray(value)) {
    //
    //     // value.forEach(val => {
    //     //   form.innerHTML += `<input type="hidden" name="${key}[]" value="${val}">`;
    //     // });
    //     if (value.length === 0) {
    //       form.innerHTML += `<input type="hidden" name="${key}[]" value="">`;
    //     } else {
    //       value.forEach(val => {
    //         form.innerHTML += `<input type="hidden" name="${key}[]" value="${val}">`;
    //       });
    //     }
    //   } else {
    //     form.innerHTML += `<input type="hidden" name="${key}" value="${value}">`;
    //   }
    // });

    document.body.appendChild(form);
    form.submit();
  }
}
